// extracted by mini-css-extract-plugin
module.exports = {"hero_section":"Hero_hero_section__Pz5-K","image":"Hero_image__lMT6K","row1":"Hero_row1__oQjmq","row2":"Hero_row2__301lQ"};